import { ODataHelper } from "../odataHelper";


export abstract class Expression
{
    abstract toQuery(): string;

    static QuoteValue(value: string | number | Date | boolean): string | number | boolean
    {
        return this.Quote(value, false);
    }

    static QuoteValueIncludingGuids(value: string | number | Date): string | number | boolean
    {
        return this.Quote(value, true);
    }

    private static Quote(value: string | number | Date | boolean, quoteGuids: boolean): string | number | boolean
    {
        if (value instanceof Date) return value.toISOString();
        else if (typeof value === "boolean")
        {
            return value;
        }
        else if (typeof value === "string")
        {
            if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]*-[0-9]{2}:[0-9]{2}$/.test(value))
            {
                return new Date(value).toISOString();
            }
            else if (
                quoteGuids ||
                !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(value.toLowerCase())
            )
                // GUID
                return `'${ODataHelper.escapeODataString(value)}'`;
        }
        return value;
    }
}
